import React from 'react';
import { NavLink, Outlet, Navigate } from 'react-router-dom';

const NAV = [
  { to: '/admin/compliance', end: true, label: 'Overview' },
  { to: '/admin/compliance/settings', label: 'Settings' },
  { to: '/admin/compliance/commission-tds', label: 'Commission & TDS' },
  { to: '/admin/compliance/gst-report', label: 'GSTR-1 Report' },
  { to: '/admin/compliance/ca-exports', label: 'CA Exports' },
  { to: '/admin/compliance/credit-notes', label: 'Credit Notes' },
];

export default function ComplianceHubLayout() {
  return (
    <div className="flex flex-col lg:flex-row gap-6 p-6 max-w-7xl mx-auto">
      <aside className="lg:w-56 shrink-0">
        <h1 className="text-lg font-bold text-[#1B375B] mb-1">Tax & Compliance</h1>
        <p className="text-xs text-gray-500 mb-3">GST · Commission · TDS · CA exports</p>
        <nav className="flex flex-wrap lg:flex-col gap-1 text-sm">
          {NAV.map(({ to, end, label }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `px-3 py-1.5 rounded-lg ${isActive ? 'bg-[#1B375B] text-white' : 'text-gray-700 hover:bg-gray-100'}`
              }
            >
              {label}
            </NavLink>
          ))}
        </nav>
      </aside>
      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
    </div>
  );
}

export function ComplianceRedirect({ to }) {
  return <Navigate to={to} replace />;
}
